import { gsap } from 'gsap/all'

const tabsMobile = {
  productsButton: document.querySelector<HTMLElement>('.tabs__mobileProducts__button'),
  dropdownBox: document.querySelector<HTMLElement>('.tabs__mobileDropdown'),

  init: (): void => {
    if (tabsMobile.productsButton != null) {
      tabsMobile.openDropdown()
      tabsMobile.closeDropdown()
    }
  },

  openDropdown: (): void => {
    gsap.set(tabsMobile.dropdownBox, { opacity: 0, display: 'none' })

    tabsMobile.productsButton?.addEventListener('click', (event) => {
      const opacityZero = tabsMobile.dropdownBox.style.opacity == '0'
      const isClickInside = tabsMobile.dropdownBox?.contains(event.target as Node)

      if (opacityZero) {
        tabsMobile.productsButton.classList.add('tabs__mobileProducts__button--active')
        gsap.to(tabsMobile.dropdownBox, {
          duration: 0.4,
          ease: 'power3.inOut',
          opacity: 1,
          display: 'flex',
        })
      } else if (!isClickInside) {
        tabsMobile.productsButton.classList.remove('tabs__mobileProducts__button--active')
        gsap.to(tabsMobile.dropdownBox, {
          duration: 0.4,
          ease: 'power3.inOut',
          opacity: 0,
          display: 'none',
        })
      }
    })
  },

  closeDropdown: (): void => {
    document.addEventListener('click', (event) => {
      const isClickOutside = !tabsMobile.dropdownBox?.contains(event.target as Node)
      const isClickOnButton = !tabsMobile.productsButton?.contains(event.target as Node)

      if (isClickOutside && isClickOnButton) {
        gsap.to(tabsMobile.dropdownBox, {
          duration: 0.4,
          ease: 'power3.inOut',
          opacity: 0,
          display: 'none',
        })
      }

      if (isClickOnButton) {
        tabsMobile.productsButton.classList.remove('tabs__mobileProducts__button--active')
      }
    })
  },
}

export default tabsMobile
